import { Controller } from "@hotwired/stimulus"

// 架電モーダル内で候補者の連絡先（電話・メール）をインライン編集する。
// 表示↔フォームを切り替え、fetch(PATCH) で保存する（モーダルを閉じずページ遷移も起こさない）。
export default class extends Controller {
  static targets = ["display", "form", "phoneValue", "emailValue"]
  static values = { url: String }

  start(event) {
    event.preventDefault()
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
  }

  cancel(event) {
    event.preventDefault()
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  async submit(event) {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Accept": "application/json", "X-CSRF-Token": csrfToken },
      body: formData
    })

    if (!response.ok) {
      console.error("連絡先の保存に失敗しました", response.status)
      return
    }

    const phone = (formData.get("candidate[phone]") || "").trim()
    const email = (formData.get("candidate[email]") || "").trim()
    this.phoneValueTarget.textContent = phone.length > 0 ? phone : "-"
    this.emailValueTarget.textContent = email.length > 0 ? email : "-"
    this.cancel(event)
  }
}
